import React from "react"
import { Redirect, Route, Switch, useParams } from "react-router-dom"
import AllPlans from "./plans"
import useEmployee from "components/employees/hooks/useEmployee"
import EmployeeButtonBar from "components/employees/EmployeeButtonBar"
import ErrorWrapper from "../../components/ErrorWrapper"
import Exoskeleton from "../../components/Exoskeleton"
import TestConfig from "./test-config"
import { Stack } from "@carrotfertility/carotene-core"

export default function EmployeesPage(): JSX.Element {
  const { employeeId } = useParams<{ employeeId: string }>()
  return <Employee employeeId={employeeId} />
}

function Employee({ employeeId }: { employeeId: string }): JSX.Element {
  const { data: employeeData, error: getEmployeeError, isLoading } = useEmployee(employeeId)

  return (
    <Stack paddingTop={"3rem"}>
      <ErrorWrapper error={getEmployeeError}>
        <Exoskeleton isLoading={isLoading}>
          {!employeeData ? null : (
            <>
              <EmployeeButtonBar employeeId={employeeId} />
              <Switch>
                <Route
                  path="/employees/:employeeId/carrot-plans"
                  render={(): JSX.Element => <AllPlans employee={employeeData.employee} />}
                />
                <Route
                  path="/employees/:employeeId/test-config"
                  render={(): JSX.Element => <TestConfig employee={employeeData.employee} />}
                />
                <Redirect to="/404" />
              </Switch>
            </>
          )}
        </Exoskeleton>
      </ErrorWrapper>
    </Stack>
  )
}
